export default {
  namespaced: true,
  state: {
    conversationList: [] // 聊天会话列表
  },
  mutations: {
    SET_CONVERSTAION_LIST(state, list = []) {
      // 更新会话列表
      state.conversationList = list
    }
  },
  actions: {
    asyncSetConversationList({ commit }, list = []) {
      // 异步更新会话列表
      commit('SET_CONVERSTAION_LIST', list)
    }
  }
}
